export const JetScreenBottCornerBottom = () => {
  return (
    <>
      <div className='f-g-line-top'>
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='15'
          height='14'
          viewBox='0 0 15 14'
          fill='none'
        >
          <path
            d='M0.607193 14L0.492188 6.09198V5.85197L0.671188 5.68797L6.17119 0.644974L6.32819 0.500977H14.0992V1.58398H6.74219L1.57719 6.31897L1.68819 13.988L0.610184 14H0.607193Z'
            fill='#2489F1'
          />
        </svg>
      </div>
      <div className='f-g-line-bottom left'>
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='17'
          height='17'
          viewBox='0 0 17 17'
          fill='none'
        >
          <path
            d='M0.142797 0L0 9.95901V10.2568L0.223555 10.4632L7.09269 16.8184L7.28965 17H17V15.6363L7.80668 15.6363L1.35216 9.67317L1.49102 0.0158806L0.143784 0.000991821L0.142797 0Z'
            fill='#2489F1'
          />
        </svg>
      </div>
      <div className='f-g-line-bottom right'>
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='17'
          height='17'
          viewBox='0 0 17 17'
          fill='none'
        >
          <path
            d='M16.8572 0L17 9.95901V10.2568L16.7764 10.4632L9.90731 16.8184L9.71035 17H0L0 15.6363L9.19332 15.6363L15.6478 9.67317L15.509 0.0158806L16.8562 0.000991821L16.8572 0Z'
            fill='#2489F1'
          />
        </svg>
      </div>
    </>
  );
};
